module.exports = __webpack_public_path__ + "static/media/promocode.bd22bc03.svg";